var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6148_21940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94444 8.16667H5.5C4.39543 8.16667 3.5 9.0621 3.5 10.1667V22.5C3.5 23.6046 4.39543 24.5 5.5 24.5H17.8333C18.9379 24.5 19.8333 23.6046 19.8333 22.5V19.0556M16.3333 3.5H24.5M24.5 3.5V11.6667M24.5 3.5L12.8333 15.1667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6148_21940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalArrow);
export default __webpack_public_path__ + "static/media/external-arrow.8213124af61e213f440736a5b493bcad.svg";
export { ForwardRef as ReactComponent };